export enum COMPARE_TYPE {
    up = 'UP',
    all = 'ALL',
    down = 'DOWN'
}